module.exports = __webpack_public_path__ + "img/Umb44_uv_logoside_4783.84d8eebc.svg";